import toast from "react-hot-toast";
import * as api from "../Api/index";

// Prefer the server's explanation over axios' generic "status code 400".
const errorMessage = (error) =>
  error?.response?.data?.message || error?.message || "Something went wrong";

// The table shows its own spinner (usersLoading), so no toast on success.
export const getAllUsers = () => async (dispatch) => {
  dispatch({ type: "USERS_LOADING", payload: true });
  try {
    const { data } = await api.getUsers();
    dispatch({ type: "GET_ALL_USER", payload: data });
  } catch (error) {
    toast.error(errorMessage(error));
  } finally {
    dispatch({ type: "USERS_LOADING", payload: false });
  }
};

// The mutating actions rethrow after toasting so callers don't carry on
// (navigate away, show success) when the request failed.
export const createUsers = (formData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Adding new user...");
    const res = await api.signup(formData);

    const data = res.data?.data?.user;

    dispatch({ type: "CREATE_FRESH_USER", payload: data });
    toast.remove(creatingId);
    toast.success("User created successfully");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(errorMessage(error));
    throw error;
  }
};
export const updateUser =
  (id, postData, successMessage = "Changes saved successfully") =>
  async (dispatch) => {
    let updatingId;
    try {
      updatingId = toast.loading("Saving changes...");
      const { data } = await api.updateUser(id, postData);
      dispatch({ type: "UPDATE_SELECTED_USER", payload: data });
      toast.remove(updatingId);
      toast.success(successMessage);
    } catch (error) {
      toast.remove(updatingId);
      toast.error(errorMessage(error));
      throw error;
    }
  };
// Returns the server response so the page can tell whether the email went out.
export const adminResetPassword = (id, password) => async () => {
  let resettingId;
  try {
    resettingId = toast.loading("Resetting password...");
    const { data } = await api.adminResetPassword(id, password);
    toast.remove(resettingId);
    if (data.emailSent) toast.success(data.message);
    else toast.error(data.message, { duration: 10000 });
    return data;
  } catch (error) {
    toast.remove(resettingId);
    toast.error(errorMessage(error));
    throw error;
  }
};
export const deleteUser = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting user...");
    await api.deleteUser(id);
    dispatch({ type: "DELETE_SELECTED_USER", payload: id });
    toast.remove(deletingId);
    toast.success("User deleted successfully");
  } catch (error) {
    toast.remove(deletingId);
    toast.error(errorMessage(error));
    throw error;
  }
};

// Lost phone: removes the user's authenticator app; refreshes the list so the
// page shows it gone.
export const resetUserTwoFactor = (id) => async (dispatch) => {
  let resettingId;
  try {
    resettingId = toast.loading("Removing authenticator app...");
    const { data } = await api.resetUserTwoFactor(id);
    toast.remove(resettingId);
    toast.success(data.message);
    dispatch(getAllUsers());
  } catch (error) {
    toast.remove(resettingId);
    toast.error(errorMessage(error));
    throw error;
  }
};
